module.exports = __webpack_public_path__ + "static/media/LESStreetA0187_bg_clean_v001.b6e8ee20.webp";